<div class="modal-container">
	<div class="modal-container--container">
		<section
			[ngClass]="{
				'modal-container--header': !transparent,
				'modal-container--header-transparent': transparent
			}"
		>
			<ng-content select="[header]"></ng-content>
		</section>

		<section
			class="modal-container--body"
			[ngClass]="{ 'margin-body': footerBorder }"
		>
			<ng-content select="[body]"></ng-content>
		</section>

		<section
			class="modal-container--footer"
			[ngClass]="{ 'footer-border': footerBorder }"
		>
			<ng-content select="[footer]"></ng-content>
		</section>
	</div>
</div>
